<template>
  <div class="ParticularReconciliation">
    <DtList :orderId="orderId" @priceList="priceList"></DtList>
  </div>
</template>

<script>
import DtList from "../common/DtList";
export default {
  created() {
    this.orderId = localStorage.getItem("orderId");
  },
  data() {
    return {
      orderId: ""
    };
  },
  methods: {
    priceList(DTList) {
      this.DTList = DTList;
      this.$emit("priceList", DTList);
    }
  },
  components: {
    DtList
  }
};
</script>

<style scoped>
.ParticularReconciliation {
  height: 100%;
}
</style>